export enum BookingErrorCode {
	ValidationError = 65,
	UnableToConfirm = 66,
	RestrictedLocation = 67,
	InvalidSession = 68,
	MultipleFamilyMatches = 69,
	DidNotReceiveCode = 70,
	NotAvailable = 71, // it doesn't come from the backend
	PetRequiresAttention = 72,
	LargePet = 73,
	TimeNoLongerAvailable = 74,
	PaymentIssue = 75,
	PermanentPaymentIssue = 76,
	PetHasExistingAppointment = 85,
	InvalidFamily = 86,
	NoAvailableAssistance = 87,
	IgnoredForAllVetsPetType = 88,
	IncompleteBookingData = 89,
	RequestCallBack = 152, // it doesn't come from the backend
}
